import ArbitrageTransactionInquiry from './arbitrage-transaction-inquiry.vue'
export default ArbitrageTransactionInquiry
